import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';
import * as moment from 'moment-timezone';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  UserContext
} from '../../../../services/user-context/user-context';

@Component({
  selector: 'app-user-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'user-dialog.template.html',
  styles: [
    "app-user-dialog mat-dialog-container {padding:0;}",
    "app-user-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-user-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ]
})

export class UserDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    lastName: '',
    firstName: '',
    email: '',
    role: '',
    password: '',
    confirm: ''
  };
  countries = ['US', 'CA'];
  designations:string[] = ['live:us', 'live:ca', 'deferred:us', 'deferred:ca'];
  roles:string[] = [];
  user:any;
  timezones:string[];

  public validationMessages = {
    lastName: {minlength: 'Minimum 2 characters', required: 'Last name required'},
    firstName: {minlength: 'Minimum 2 characters', required: 'First name required'},
    email: {minlength: 'Valid email required', required: 'Valid email required', email: 'Valid email required'},
    role: {required: 'Role is required'},
    locations: {required: 'Location is required'},
    password: {minlength: 'Minimum 8 characters', required: 'Password is required'},
    confirm: {minlength: 'Retype password', required: 'Retype password', equalTo: 'Passwords do not match'}
  };

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<UserDialogComponent>,
              private userContext: UserContext,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    if( userContext.isAdministrator()) {
      this.roles.push("owner");
      this.roles.push("manager");
    }

    if( userContext.hasRole("manager"))
      this.roles.push("manager");

    this.roles.push("associate");

    this.timezones = Array.from(new Set<string>(moment.tz.zonesForCountry('US').concat(moment.tz.zonesForCountry('CA')))).sort();
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      lastName: new FormControl( this.data.user ? this.data.user.lastName : '', [
        Validators.required,
        Validators.minLength(2)
      ]),
      firstName: new FormControl(this.data.user ? this.data.user.firstName : '', [
        Validators.required,
        Validators.minLength(2)
      ]),
      email: new FormControl(this.data.user ? this.data.user.email : '', [
        Validators.required,
        Validators.email,
        Validators.minLength(3)
      ]),
      role: new FormControl(this.data.user ? this.data.user.role : '', [
        Validators.required
      ]),
      titles: new FormControl(this.data.user ? (this.data.user.titles || []).join(" ") : '', [
      ]),
      designations: new FormControl(this.data.user ? this.data.user.designations : [], [
      ]),
      locations: new FormControl(this.data.user ? this.data.user.locations : '', [
        Validators.required
      ]),
      country: new FormControl(this.data.user ? this.data.user.country : '', [
        Validators.required
      ]),
      timezone: new FormControl(this.data.user ? this.data.user.timezone || moment.tz.guess() : moment.tz.guess(), [
        Validators.required
      ]),
      password: new FormControl('', this.data.user ? [Validators.minLength(8)] : [
        Validators.required,
        Validators.minLength(8),
        equalityValidator('confirm', false)
      ]),
      confirm: new FormControl('', this.data.user ? [Validators.minLength(8)] : [
        Validators.required,
        Validators.minLength(8),
        equalityValidator('password', true)
      ]),
      external_id: new FormControl(this.data.user ? this.data.user.external_id : '', [
      ])
    });

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  public onValueChanged(data?: any): void {
    if (!this.form) { return; }
    const form = this.form;

    for ( const field of Object.keys( this.formErrors) ) {
      this.formErrors[field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];

        for ( const key of Object.keys( control.errors ) ) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public isManager() {
    return this.userContext.hasRole('manager');
  }

  public isOwner() {
    return this.userContext.hasRole('owner');
  }

  public save() {
    this.dialogRef.close(this.form.value);
  }

  public cancel() {
    this.dialogRef.close();
  }
}

export function equalityValidator(equalTo: string, hostError: boolean): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const compareTo = control.root.get(equalTo);
    if ( hostError ) {
      return !compareTo || compareTo.value === control.value ? null : {'equalTo': {value: false}};
    } else {
      if ( compareTo && compareTo.touched ) {
        if ( compareTo.value !== control.value ) {
          compareTo.setErrors({'equalTo': {value: false}});
        } else {
          compareTo.setErrors( null );
        }
      }
      return null;
    }
  };
}
